import axios from 'axios';
import { internalCodeTranslationKeys, STATUS_BAD_REQUEST, STATUS_NOT_FOUND } from '../constants';
import { LocalizationKeys } from '../models/localizationKeys';
var customAxiosInstance;
export var getCustomAxios = function getCustomAxios(currentLanguage) {
  if (!customAxiosInstance) {
    customAxiosInstance = axios.create({
      baseURL: typeof window === 'undefined' ? '' : window.location.origin,
      headers: {
        'Accept-Language': currentLanguage
      }
    });
  }

  return customAxiosInstance;
};
export var handleAxiosError = function handleAxiosError(_ref) {
  var callback = _ref.callback,
      error = _ref.error,
      translateMessage = _ref.translateMessage;
  // eslint-disable-next-line no-console -- We want to log errors in case of failed calls.
  console.error(error);

  if (axios.isAxiosError(error) && error.response !== undefined) {
    var _Errors$, _Errors$2;

    var _ref2 = error.response.data,
        Errors = _ref2.Errors;
    var statusCode = error.response.status;
    var message = Errors === null || Errors === void 0 ? void 0 : (_Errors$ = Errors[0]) === null || _Errors$ === void 0 ? void 0 : _Errors$.Message;
    var internalErrorCode = Errors === null || Errors === void 0 ? void 0 : (_Errors$2 = Errors[0]) === null || _Errors$2 === void 0 ? void 0 : _Errors$2.Code;

    if (message && statusCode === STATUS_BAD_REQUEST) {
      var translateKey = internalErrorCode ? internalCodeTranslationKeys[internalErrorCode] : message;

      if (internalErrorCode && translateKey) {
        translateMessage(translateKey);
      } else {
        // Set default message in case of internal code is not implemented.
        translateMessage(message);
      }
    } else if (statusCode === STATUS_NOT_FOUND) {
      translateMessage(LocalizationKeys.invalidCredentials.id); // This is wrong but without change of whole translation logic I can't use key from translation keys.
    } else {
      translateMessage(LocalizationKeys.errorOccured.id); // Same as error above
    }
  }

  if (callback) {
    callback();
  }
};